/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedPortfolioTagRequest
 */
export interface PatchedPortfolioTagRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedPortfolioTagRequest
   */
  name?: string
}

/**
 * Check if a given object implements the PatchedPortfolioTagRequest interface.
 */
export function instanceOfPatchedPortfolioTagRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedPortfolioTagRequestFromJSON(json: any): PatchedPortfolioTagRequest {
  return PatchedPortfolioTagRequestFromJSONTyped(json, false)
}

export function PatchedPortfolioTagRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedPortfolioTagRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
  }
}

export function PatchedPortfolioTagRequestToJSON(value?: PatchedPortfolioTagRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
